import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { useState, useEffect } from "react";

function LoadingScreen({ onComplete }: { onComplete: () => void }) {
  const [phase, setPhase] = useState<'enter' | 'hold' | 'exit'>('enter');

  useEffect(() => {
    const holdTimer = setTimeout(() => setPhase('hold'), 1200);
    const exitTimer = setTimeout(() => setPhase('exit'), 2200);
    const doneTimer = setTimeout(() => onComplete(), 2800);
    return () => {
      clearTimeout(holdTimer);
      clearTimeout(exitTimer);
      clearTimeout(doneTimer);
    };
  }, [onComplete]);

  return (
    <div
      className={`fixed inset-0 z-[100] flex items-center justify-center bg-background-50 transition-opacity duration-700 ${
        phase === 'exit' ? 'opacity-0 pointer-events-none' : 'opacity-100'
      }`}
    >
      <div className="flex flex-col items-center gap-6">
        <img
          src="https://storage.helloreaddy.io/project_files/24e881c6-f294-4a58-bd38-599192c75103/3bef8fe4-93fc-4871-96d0-8453306d9513_compressed_cleanup_naija_primary.webp"
          alt="CleanUp Naija"
          className={`h-20 md:h-28 w-auto object-contain transition-all duration-1000 ${
            phase === 'enter'
              ? 'opacity-0 scale-[0.85] translate-y-6 blur-sm'
              : phase === 'hold'
              ? 'opacity-100 scale-100 translate-y-0 blur-0'
              : 'opacity-0 scale-105 -translate-y-4 blur-sm'
          }`}
        />
        <div
          className={`flex items-center gap-1.5 transition-opacity duration-500 ${
            phase === 'hold' ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <span className="w-2 h-2 rounded-full bg-primary-500 animate-loader-pulse" />
          <span
            className="w-2 h-2 rounded-full bg-primary-500 animate-loader-pulse"
            style={{ animationDelay: '0.2s' }}
          />
          <span
            className="w-2 h-2 rounded-full bg-primary-500 animate-loader-pulse"
            style={{ animationDelay: '0.4s' }}
          />
        </div>
      </div>
    </div>
  );
}

function App() {
  const [loading, setLoading] = useState(true);

  return (
    <>
    {loading && <LoadingScreen onComplete={() => setLoading(false)} />}

    {!loading && <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <AppRoutes />
      </BrowserRouter>
    </I18nextProvider>}
    </>
  );
}

export default App;